import { useContext } from 'react';
import TranslateFunctionContext from '../contexts/translate-function.js';
export default function useTranslate() {
    return useContext(TranslateFunctionContext);
}
//# sourceMappingURL=use-translate.js.map